import { DynamicContentSchemaStore } from './dynamic-content.store';
import { DynamicContentSchemaQuery } from './dynamic-content.query';
import { BaseFacade } from '../base/base.facade';
import { DynamicContentSchemaService } from './dynamic-content.service';
import { TranslateService } from '@ngx-translate/core';
import { ContentFactory } from '../../squidex/factories/content.factory';
import { DynamicContentSchemaState } from './dynamic-content.state';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';

export class DynamicContentSchemaFacade extends BaseFacade {
  constructor(
    schemaName: string,
    contentFactory: ContentFactory,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    if (!schemaName) {
      throw new Error('Schema name invalid');
    }
    const genericService = new DynamicContentSchemaService(schemaName, contentFactory);
    const genericStore = new DynamicContentSchemaStore(new DynamicContentSchemaState(), schemaName);
    const genericQuery = new DynamicContentSchemaQuery(genericStore);

    super(genericService,
      genericStore,
      genericQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(schemaName),
      translateService,
      schemaName + '-facade'
      );
  }
}
